import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import ContextToolsRow from './ContextToolsRow'
import { LoadingSpinner } from '../../../../components'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const ContextTools = props => {
  const [currentState] = useStateValue()
  const [loading, setLoading] = useState(true)
  const [contextActs, setContextActs] = useState([])
  const [canvasActs, setCanvasActs] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(
          endpoints.getContextActs({
            coursenum: currentState.contextToolsCoursenum,
            contextId: props.contextId,
          })
        )
        setContextActs(resp.data.acts)
        setCanvasActs(resp.data.canvasActs)
        setLoading(false)
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
  }, [])

  return (
    <div className="card-myed">
      {loading ? (
        <div className="text-center">
          <LoadingSpinner style={{ fontSize: '50px' }} />
        </div>
      ) : (
        <React.Fragment>
          <h3>Map Assessments</h3>
          <h4>Course {currentState.contextToolsCoursenum}</h4>
          <div className="table-responsive">
          <table className="w-100">
            <thead>
              <tr>
                <th />
                <th>MyEducator Assessment</th>
                <th />
                <th>Saved Canvas ID</th>
                <th />
                <th>Matching Canvas Assignment</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {contextActs.map((act, i) => (
                <ContextToolsRow
                  act={act}
                  canvasActs={canvasActs}
                  updateCanvasActs={setCanvasActs}
                  updateContextActs={setContextActs}
                  contextId={props.contextId}
                  iteration={i}
                  key={i}
                />
              ))}
            </tbody>
          </table>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

ContextTools.propTypes = {
  contextId: PropTypes.string,
}

export default ContextTools
